'use strict';

const CriteoTracker = {}
CriteoTracker.ON_VIEW_PERCENTAGE_THRESHOLD = 0.5;
CriteoTracker.ON_VIEW_DELAY_MS = 1000;
CriteoTracker.STATUS = {}
CriteoTracker.STATUS.NOT_VIEWED = "NOT_VIEWED";
CriteoTracker.STATUS.CHECK_IN_PROGRESS = "CHECK_IN_PROGRESS";
CriteoTracker.STATUS.VIEWED = "VIEWED";
CriteoTracker._sentBeacons = new Set();

CriteoTracker._loadBeaconAsImage = function (beaconUrl) {
    if (beaconUrl) {
        const loadImage = function (deferred) {
            const beaconImage = new Image();
            beaconImage.onload = onLoad;
            beaconImage.onerror = onError;
            beaconImage.onabort = onError;

            beaconImage.src = beaconUrl;

            function onLoad() {
                unbindEvents();
                deferred.resolve(beaconImage);
            }

            function onError() {
                unbindEvents();
                deferred.reject(beaconImage);
            }

            function unbindEvents() {
                beaconImage.onload = null;
                beaconImage.onerror = null;
                beaconImage.onabort = null;
            }
        }

        return $.Deferred(loadImage).promise();
    } else {
        return $().promise();
    }
};

CriteoTracker._sendCriteoTrackEvent = function (beaconUrl) {
    if (beaconUrl && !CriteoTracker._sentBeacons.has(beaconUrl)) {
        CriteoTracker._sentBeacons.add(beaconUrl);

        if (typeof window.navigator !== 'undefined' && typeof window.navigator.sendBeacon === 'function') {
            navigator.sendBeacon(beaconUrl);
            return $().promise();
        } else {
            // Edge 12-13 and other old browsers
            return CriteoTracker._loadBeaconAsImage(beaconUrl);
        }
    }
};

CriteoTracker._registerOnViewElementEvent = function ($element, beaconUrl, callback) {
    if (!$element || !beaconUrl) {
        return;
    }

    const elementContext = {};
    elementContext.status = CriteoTracker.STATUS.NOT_VIEWED;

    // Called each time the visibility changes (resize/scroll)
    function onFracsChange(fracs) {
        // If the element has already been seen, then ignore
        if (elementContext.status === CriteoTracker.STATUS.NOT_VIEWED && fracs.visible > CriteoTracker.ON_VIEW_PERCENTAGE_THRESHOLD) {
            elementContext.status = CriteoTracker.STATUS.CHECK_IN_PROGRESS;
            // Check again in x seconds to see if the element is still visible to mark it as seen
            setTimeout(doFinalCheck, CriteoTracker.ON_VIEW_DELAY_MS)
        }
    }

    function doFinalCheck() {
        if (elementContext.status === CriteoTracker.STATUS.VIEWED) {
            return;
        }

        if ($element.fracs().visible > CriteoTracker.ON_VIEW_PERCENTAGE_THRESHOLD) {
            CriteoTracker._sendCriteoTrackEvent(beaconUrl);
            elementContext.status = CriteoTracker.STATUS.VIEWED;
            if (callback) {
                callback();
            }
        } else {
            elementContext.status = CriteoTracker.STATUS.NOT_VIEWED;
        }
    }

    $element.fracs(onFracsChange);
};

const CriteoBannerTracker = {}

CriteoBannerTracker.sendOnLoadEvent = CriteoTracker._sendCriteoTrackEvent;

CriteoBannerTracker.sendOnClickEvent = CriteoTracker._sendCriteoTrackEvent;

CriteoBannerTracker.registerOnViewEvent = CriteoTracker._registerOnViewElementEvent;

const CriteoButterflyTracker = {}

CriteoButterflyTracker.sendFormatOnLoadEvent = CriteoTracker._sendCriteoTrackEvent;

CriteoButterflyTracker.sendFormatOnClickEvent = CriteoTracker._sendCriteoTrackEvent;

CriteoButterflyTracker.registerFormatOnViewEvent = CriteoTracker._registerOnViewElementEvent;

const CriteoProductTracker = function (formatLevelOnLoadBeacon, formatLevelOnViewBeacon) {
    this.formatLevelOnLoadBeacon = formatLevelOnLoadBeacon;
    this.formatLevelOnViewBeacon = formatLevelOnViewBeacon;

    this.formatLevelOnLoadStatus = CriteoTracker.STATUS.NOT_VIEWED;
    this.formatLevelOnViewStatus = CriteoTracker.STATUS.NOT_VIEWED;
}

CriteoProductTracker.prototype.sendOnLoadEvent = function (productOnLoadBeaconUrl) {
    const onLoadFormatPromise = this._sendOnLoadFormatEvent();
    const onLoadPromise = CriteoTracker._sendCriteoTrackEvent(productOnLoadBeaconUrl);
    return $.when(onLoadFormatPromise, onLoadPromise);
}

CriteoProductTracker.prototype._sendOnLoadFormatEvent = function () {
    // If the format-level on-load beacon has not been loaded yet, send it just once
    if (this.formatLevelOnLoadStatus !== CriteoTracker.STATUS.VIEWED && this.formatLevelOnLoadBeacon) {
        this.formatLevelOnLoadStatus = CriteoTracker.STATUS.VIEWED;
        return CriteoTracker._sendCriteoTrackEvent(this.formatLevelOnLoadBeacon);
    } else {
        return $().promise();
    }
};

CriteoProductTracker.prototype.registerOnViewEvent = function ($element, criteoBeaconUrl) {
    const that = this;
    const callback = function () {
        that._sendOnViewFormatEvent();
    };
    CriteoTracker._registerOnViewElementEvent($element, criteoBeaconUrl, callback);
};

CriteoProductTracker.prototype._sendOnViewFormatEvent = function () {
    // If the format-level on-view beacon has not been loaded yet, send it just once
    if (this.formatLevelOnViewStatus !== CriteoTracker.STATUS.VIEWED && this.formatLevelOnViewBeacon) {
        this.formatLevelOnViewStatus = CriteoTracker.STATUS.VIEWED;
        return CriteoTracker._sendCriteoTrackEvent(this.formatLevelOnViewBeacon);
    } else {
        return $().promise();
    }
};

CriteoProductTracker.sendOnClickEvent = CriteoTracker._sendCriteoTrackEvent;

CriteoProductTracker.sendOnBasketChangeEvent = CriteoTracker._sendCriteoTrackEvent;

CriteoProductTracker.sendOnWishListEvent = CriteoTracker._sendCriteoTrackEvent;